<div class="content_container">
    <div class="logo_container">
      <a routerLink="/">
        <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
      </a>
    </div>
    <div class="unavailable">Page currently unavailable</div>
</div>